<template>
  <DropdownMenuSeparator
    v-bind="delegatedProps"
    :class="cn('tw:-mx-1 tw:my-1 tw:h-px tw:bg-muted', props.class)"
  />
</template>

<script setup>
import { DropdownMenuSeparator } from 'reka-ui'
import { computed } from 'vue'
import { cn } from '@/shadcn/lib/utils'

const props = defineProps({
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
})

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})
</script>
